import React from 'react';
import MeasureSheetList from './MeasureSheetList';

const MeasureSheet = () => {
  return <MeasureSheetList />;
};

export default MeasureSheet;
